module.exports = __webpack_public_path__ + "static/media/map-locations.93519a8b.png";